"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.accessTypeMessages = exports.AccessType = void 0;
const schema_1 = require("../../../../schema");
var AccessType;
(function (AccessType) {
    AccessType["ACCESS_TENCKHOFF_CATHETER"] = "access_tenckhoff_catheter";
    AccessType["ACCESS_TEMPORARY_CATHETER"] = "access_temporary_catheter";
    AccessType["ACCESS_PERMANENT_CATHETER"] = "access_permanent_catheter";
    AccessType["ACCESS_ARTERIOVENOUS_FISTULA"] = "access_arteriovenous_fistula";
    AccessType["ACCESS_OTHER"] = "access_other";
})(AccessType || (exports.AccessType = AccessType = {}));
exports.accessTypeMessages = {
    [AccessType.ACCESS_TENCKHOFF_CATHETER]: {
        id: "ktx.basicRegistrationData.waitingListData.access.accessType.ACCESS_TENCKHOFF_CATHETER",
        defaultMessage: "Tenckhoff katéter"
    },
    [AccessType.ACCESS_TEMPORARY_CATHETER]: {
        id: "ktx.basicRegistrationData.waitingListData.access.accessType.ACCESS_TEMPORARY_CATHETER",
        defaultMessage: "Átmeneti kanül"
    },
    [AccessType.ACCESS_PERMANENT_CATHETER]: {
        id: "ktx.basicRegistrationData.waitingListData.access.accessType.ACCESS_PERMANENT_CATHETER",
        defaultMessage: "Tartós kanül"
    },
    [AccessType.ACCESS_ARTERIOVENOUS_FISTULA]: {
        id: "ktx.basicRegistrationData.waitingListData.access.accessType.ACCESS_ARTERIOVENOUS_FISTULA",
        defaultMessage: "Arteriovenous fistula"
    },
    [AccessType.ACCESS_OTHER]: {
        id: "ktx.basicRegistrationData.waitingListData.access.accessType.ACCESS_OTHER",
        defaultMessage: "Egyéb vérnyerés"
    }
};
const accessType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(AccessType.ACCESS_TENCKHOFF_CATHETER)
        .interpretation({ vocab: "ktx", code: "access_tenckhoff_catheter" })
        .tag({ vocab: "ktx", code: "access" }),
    schema_1.Schema.singleChoiceItem(AccessType.ACCESS_TEMPORARY_CATHETER)
        .interpretation({ vocab: "ktx", code: "access_temporary_catheter" })
        .tag({ vocab: "ktx", code: "access" }),
    schema_1.Schema.singleChoiceItem(AccessType.ACCESS_PERMANENT_CATHETER)
        .interpretation({ vocab: "ktx", code: "access_permanent_catheter" })
        .tag({ vocab: "ktx", code: "access" }),
    schema_1.Schema.singleChoiceItem(AccessType.ACCESS_ARTERIOVENOUS_FISTULA)
        .interpretation({ vocab: "ktx", code: "access_arteriovenous_fistula" })
        .tag({ vocab: "ktx", code: "access" }),
    schema_1.Schema.singleChoiceItem(AccessType.ACCESS_OTHER)
]);
const accessTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../accessType} === "access_other"`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "access_other" })
    .tag({ vocab: "ktx", code: "access" }));
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ accessType, accessTypeOther, comment })
    .interpretation({ vocab: "ktx", code: "access_statement" })
    .tag({ vocab: "fyrms", code: "action" });
